import { render } from "./PerformanceCharts.vue?vue&type=template&id=7a0314b6"
import script from "./PerformanceCharts.vue?vue&type=script&lang=js"
export * from "./PerformanceCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__